import { Box, styled, SxProps, Typography } from "@mui/material";
import { FC } from "react";

import { STREETLIGHT_STATUS_TYPE } from "../../types/streetlight-status-type";
import { StreetlightStatusIndicator } from "../streetlight-status-indicator/streetlight-status-indicator";

export interface StreetlightStatusItemProps {
  /** show the title and status stacked on top of each other or side by side*/
  areElementsStacked?: boolean;
  status: STREETLIGHT_STATUS_TYPE | string | undefined;
  position?: 1 | 2 | 3;
  name: string;
  fontSize?: string;
  sx?: SxProps;
}

const StackedContainer = styled(Box)({
  display: "grid",
  gridTemplateRows: "repeat(2, 1fr)",
  justifyContent: "center",
  fontWeight: 500,
  fontSize: 14,
});

const SideBySideContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: 500,
  fontSize: 14,
});

/** Styled line display of a sub-status */
export const StreetlightStatusItem: FC<StreetlightStatusItemProps> = ({
  status,
  name,
  areElementsStacked = true,
  sx,
  position,
}) => {
  return areElementsStacked ? (
    <StackedContainer data-testid={`StatusItem-${name}`}>
      <Typography variant="subtitle2">{name}</Typography>
      <StreetlightStatusIndicator
        data-testid={`StatusIndicator-${name}`}
        status={status}
        position={position}
        cardProps={{ sx }}
      />
    </StackedContainer>
  ) : (
    <SideBySideContainer data-testid={`StatusItem-${name}`}>
      <Typography variant="subtitle2">{name}</Typography>
      <StreetlightStatusIndicator
        data-testid={`StatusIndicator-${name}`}
        status={status}
        position={position}
        cardProps={{ sx }}
      />
    </SideBySideContainer>
  );
};
